import React from "react";
import TnALocationCodesTable from "../../containers/TnALocationCodesTable/TnALocationCodesTable";

const TnALocationCodesPage = () => {
  return (
    <>
      <TnALocationCodesTable />
    </>
  );
};

export default TnALocationCodesPage;
